import {
    SkyNetDataGridFilterType,
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    LeaseType,
    CollectionServiceType,
    DeliveryServiceType,
} from 'app/enums/label.enums'

// Type definition
export type LaneGroup = {
    laneGroupNumber: string
    deliveryServiceType: DeliveryServiceType
    handoverPointLocationName: string
    collectionServiceType: CollectionServiceType
    collectionDropoffPointLocationName: string
    leaseType: LeaseType
    originAirportsIataCode: string[]
    destinationAirportsIataCode: string[]
    tempRange: string
    additionalFeesValidTo: string | Date
    laneFeesValidTo: string | Date
}

// Config array
const columns: SkyDataGridColumnDefinition<LaneGroup>[] = [
    {
        name: 'laneGroupNumber',
        labelKey: 'LANE_GROUP',
    },
    {
        name: 'deliveryServiceType',
        labelKey: 'DELIVERY_SERVICE_TYPE',
        filterField: 'deliveryServiceType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: DeliveryServiceType,
    },
    {
        name: 'handoverPointLocationName',
        labelKey: 'HANDOVER_POINT',
        filterField: 'handoverPointLocationName',
        filterType: FilterType.Array,
    },
    {
        name: 'collectionServiceType',
        labelKey: 'COLLECTION_SERVICE_TYPE',
        filterField: 'collectionServiceType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: CollectionServiceType,
    },
    {
        name: 'collectionDropoffPointLocationName',
        labelKey: 'COLLECTION_POINT',
        filterField: 'collectionDropoffPointLocationName',
        filterType: FilterType.Array,
    },
    {
        name: 'leaseType',
        labelKey: 'LEASE_TYPE',
        filterField: 'leaseType',
        filterType: FilterType.Array,
        width: 120,
        componentName: 'EnumValue',
        allowedValuesEnum: LeaseType,
    },
    {
        name: 'originAirportsIataCode',
        labelKey: 'FROM',
        filterField: 'originAirportsIataCode',
        filterType: FilterType.Array,
        width: 70,
        componentName: 'List',
    },
    {
        name: 'destinationAirportsIataCode',
        labelKey: 'TO',
        filterField: 'destinationAirportsIataCode',
        filterType: FilterType.Array,
        width: 70,
        componentName: 'List',
    },
    {
        name: 'tempRange',
        labelKey: 'TEMP',
        filterField: 'tempRange',
        filterType: FilterType.Array,
        width: 70,
    },
    {
        name: 'additionalFeesValidTo',
        labelKey: 'ADDITIONAL_FEES_VALID_TO',
        filterField: 'additionalFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
    },
    {
        name: 'laneFeesValidTo',
        labelKey: 'LANE_FEES_VALID_TO',
        filterField: 'laneFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
    },
]

export default columns
